<template>
    <div class="has-shadow position-relative">

        <span class="day-to-go day-to-go--cancelled" v-if="reservation.IsCancelled">Cancelled</span>
        <span class="day-to-go" v-else>


            <span v-if="reservation.DaysToStay == 0">Today</span>
            <span v-if="reservation.DaysToStay > 0">{{reservation.DaysToStay}} days to go!</span>
            <span v-if="reservation.DaysToStay < 0">{{-reservation.DaysToStay}} days ago!</span>



        </span>
        <div class="row">
            <div class="col-xl-7">
                <div class="stay-booking-gallery">
                    <single-image-gallery v-bind:images="images"></single-image-gallery>
                </div>
            </div>
            <div class="col-xl-11 g-0" >
                <div class="w-100 h-100 p-4 ">


                    <h3 class="mb-2">
                        {{formatDate(reservation.ArrivalDate)}}
                    </h3>

                    <h4 class="mb-3">
                        Confirmation number: {{reservation.ConfirmationNumber}}
                    </h4>

                    <div class="row">

                        <div style="text-align:right" class="col-xl-12 mb-2 d-flex justify-content-between"><span  class="stay-info-label">Arrive:</span> {{formatDateSimple(reservation.ArrivalDate)}}</div>
                        <div style="text-align:right" class="col-xl-12 mb-2 d-flex justify-content-between"><span  class="stay-info-label">Depart:</span> {{formatDateSimple(reservation.DepartureDate)}}</div>
                        <div style="text-align:right" class="col-xl-12 mb-2 d-flex justify-content-between"><span  class="stay-info-label">Check-in:</span>{{configuration.BookingDefaults.CheckInTime}}</div>
                        <div style="text-align:right" class="col-xl-12 mb-2 d-flex justify-content-between"><span  class="stay-info-label">Check-out:</span>{{configuration.BookingDefaults.CheckOutTime}}</div>
                        <div style="text-align:right" class="col-xl-12 mb-2 d-flex justify-content-between"><span  class="stay-info-label">Rooms(s):</span>{{reservation.RoomCount}}</div>
                        <div style="text-align:right" class="col-xl-12 mb-2 d-flex justify-content-between"><span  class="stay-info-label">Guests:</span>{{formatGuests(reservation.TotalGuests)}}</div>
      

                        <div class="col-xl-24 mb-2 d-flex justify-content-between"
                             v-for="(room, index) in reservation.RoomStays"
                             v-bind:key="room.InternalIdentifier">
                            <span class="w-100" v-if="reservation.RoomStays.length > 1">
                                <span class="stay-info-label d-inline-block" style="margin-right: 10px;">Room Type {{room.Leg}} </span>{{getRoomType(room.RoomCode)}}
                            </span>
                            <span class="w-100" v-else>
                                <span class="stay-info-label d-inline-block" style="margin-right: 10px;">Room Type </span>{{getRoomType(room.RoomCode)}}

                            </span>

                        </div>

                        <div v-if="reservation.HasSpa && !reservation.IsCancelled" class="col-xl-24 mb-2 d-flex justify-content-between">
                            <info-box v-bind:type="'alert'">
                                <template v-slot:body>
                                    <p>
                                        View details to see your Spa Itinerary
                                    </p>

                                </template>
                            </info-box>

                        </div>

                    </div>

                    <div class="row" v-if="reservation.DaysToStay <= 0 && !reservation.IsCancelled">
                        <div class="col-24">
                            <div class="trip-advisor">
                                <span class="enjoy">We hope you've enjoyed your stay!</span>
                                <span class="review">Why not leave us <a href="https://www.tripadvisor.co.uk/UserReviewEdit-g1933492-d1554280-Rockliffe_Hall-Hurworth_on_Tees_Darlington_County_Durham_England.html" target="_blank" class="color-gold">A Review</a>?</span>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="d-flex flex-column justify-content-end w-100 h-100">
                    <div v-if="reservation.Total > 0">
                        <div class="flex-grow-1 p-4 account-pricing-detail ">
                            <span class="total-label">Total</span>
                            <span class="total-amount">&pound;{{priceFormatted(reservation.Total)}}</span>
                        </div>


                        <div>
                            <div v-if="showPayment && !reservation.IsCancelled">
                                <div class="account-payment paid" v-if="reservation.Deposit > 0">
                                    <div class="row g-0">
                                        <div class="col-16">Deposit:</div>
                                        <div class="col-8 d-flex justify-content-end">
                                            <strong>&pound;{{priceFormatted(reservation.Deposit)}}</strong>
                                        </div>
                                    </div>
                                </div>

                                <div class="account-payment to-pay" v-if="reservation.Total - reservation.Deposit > 0">
                                    <div class="row g-0">
                                        <div class="col-16">Due on arrival:</div>
                                        <div class="col-8 d-flex justify-content-end">
                                            <strong>&pound;{{priceFormatted(reservation.Total - reservation.Deposit)}}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                        <a v-if="showBookAgain" href="/booking/#/stay" class="btn btn--continue btn-account-action btn--white btn--block">
                            Book Again
                        </a>

                        <router-link class="btn btn--continue btn-account-action btn--slate-blue btn--block" v-bind:to="{name : 'account_stay_booking', params: { id: reservation.ConfirmationNumber }}">
                            Details
                        </router-link>


                </div>
            </div>
        </div>
    </div>




</template>

<script>
    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';
    import { accountStore } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';

    export default {
        name: 'AccountStayBookingPanel',
        props: {
            reservation: {
                type: Object,
                required: true
            },
            showBookAgain: Boolean,
            showPayment: Boolean,
            showTripAdvisor: Boolean
        },
        components: {
            InfoBox,
            SingleImageGallery
        },
        computed: {
            configuration() {
                return accountStore.getters.accountConfiguration;
            },
            images() {


                let result = [];
                if (this.configuration != null) {
                    for (var ri = 0; ri < this.reservation.RoomStays.length; ri++) {
                        var room = this.reservation.RoomStays[ri];

                        let roomType = this.configuration.RoomTypes.find(item => item.PMSCode == room.RoomCode);
                        if (roomType != null) {
                            result = result.concat(roomType.Images);
                        }
                    }
                }

                return result;
            },
        },
        methods: {
            formatDate(date) {
                return moment(date).format("Do MMMM YYYY");
            },
            formatDateSimple(date) {
                return moment(date).format("DD/MM/YYYY");
            },
            formatGuests(guestCount) {
                let result = "";

                if (guestCount.Adults == 1) {
                    result += "1 adult"
                }
                if (guestCount.Adults > 1) {
                    result += guestCount.Adults + ' adults';
                }

               

                if (guestCount.Adults > 0 && guestCount.Children > 0 && guestCount.Infants == 0) {
                    result += " & ";
                }
                else if (guestCount.Adults > 0 && guestCount.Children > 0 && guestCount.Infants > 0) {
                    result += " , ";
                }


                if (guestCount.Children > 0) {

                    if (guestCount.Children == 1) {
                        result += "1 child";
                    }
                    if (guestCount.Children > 1) {
                        result += guestCount.Children + ' children';
                    }

                }


                if (guestCount.Infants > 0) {
                    result += " & ";
                    if (guestCount.Infants == 1) {
                        result += "1 infant";
                    }
                    if (guestCount.Infants > 1) {
                        result += guestCount.Infants + ' infants';
                    }

                }


                return result;
            },
            getRoomType(roomCode) {

                if (this.configuration != null) {

                    let roomType = this.configuration.RoomTypes.find(item => item.PMSCode == roomCode);
                    if (roomType != null) {
                        return roomType.DisplayName;
                    }
                }


                return roomCode;


            },
            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            }
        }


    }
</script>

<style>
    .stay-booking-gallery {
        min-height: 224px;
        height: 100%;
        width: 100%;
    }

    .stay-info-label {
        font-weight: bold;
    }

    .day-to-go {
        position: absolute;
        left: -6px;
        top: 10px;
        font-size: 12px;
        background-color: #37513c;
        color: white;
        text-transform: uppercase;
        font-weight: bold;
        padding: 10px 14px;
        z-index: 3;
    }


    .day-to-go--cancelled {
        background-color: rgb(161, 0, 0);
    }

    .account-pricing-detail {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

        .account-pricing-detail .total-label {
            display: block;
            font-family: 'Playfair Display';
            font-style: italic;
            font-size: 18px;
        }

        .account-pricing-detail .total-amount {
            display: block;
            font-family: Montserrat;
            font-weight: bold;
            font-size: 36px;
        }

    .btn-account-action {
        padding-right: 24px !important;
    }

    .trip-advisor {
        margin-top: 15px;
        padding-left: 50px;
        background-size: 36px 36px;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/booking/tripadvisor.svg)
    }

        .trip-advisor span {
            display: block;
        }

            .trip-advisor span.review {
                text-transform: uppercase;
                font-weight: bold;
            }


    .account-payment {
        margin-bottom: 2px;
        padding: 5px;
    }

        .account-payment.paid {
            background-color: rgba(52,127,52, 0.15);
        }

        .account-payment.to-pay {
            background-color: rgba(161,163,91, 0.2);
        }
</style>